import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchContactpersonenForEntity,
  initialState,
} from '../services/fetchContactpersonenForEntity'

export { useContactpersonenForEntity, queryKey }

const queryKey = 'entity-contactpersonen'

const useContactpersonenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchContactpersonenForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialState.data,
  }
}
